import React from "react";
import { Modal, Button, Icon } from "antd";

const ApprovalRequiredModal = ({
  visible,
  onCancel,
  onRequestApproval,
  restrictionMessage = [],
  reqLoading
}) => {
  return (
    <Modal
      visible={visible}
      footer={null}
      closable={false}
      width={420}
      bodyStyle={{ padding: 24 }}
      centered
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3 style={{ margin: 0, fontWeight: 600 }}>Approval Required</h3>
        <Icon
          type="warning"
          theme="filled"
          style={{ color: "#ff4d4f", fontSize: 18 }}
        />
      </div>

      {/* Description */}
      <p style={{ marginTop: 12, color: "#595959", lineHeight: "20px" }}>
        The creation of this order requires approval from an authorized user
        due to the following order restriction:
      </p>

      {/* Restriction message */}
      <div
        style={{
          backgroundColor: "#fff1f0",
          color: "#cf1322",
          padding: "10px 12px",
          borderRadius: 4,
          marginTop: 12,
          fontSize: 14,
        }}
      >
        {restrictionMessage?.map((msg, index) => (
          <div key={index}>{msg}</div>
        ))}
      </div>

      {/* Footer buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 24,
        }}
      >
        <Button onClick={onCancel} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button type="primary" onClick={onRequestApproval} loading={reqLoading}>
          Request Approval
        </Button>
      </div>
    </Modal>
  );
};

export default ApprovalRequiredModal;